import { Subject } from 'rxjs/Subject';
import { Component, OnInit } from '@angular/core';
import { AlertService } from 'sce-core';
import { SearchService } from '../../search/search.service';
import { ConfirmDialogService } from 'sce-core';
import { ResourceService } from 'sce-core';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { ButtonItem } from '../../button/button.model';
import { SearchParams } from '../../search/models/search-params.model';
import { DataTableConfig } from '../../search/models/data-table-config';
import { SearchStatus } from '../../search/models/search-status.model';
import { SearchEvent } from '../../search/models/search-event';
import { ITEM_CLICK_EVENT, NEW_SEARCH_EVENT } from '../../search/search-constants';
import { SearchCriteria, Condition, Clause } from '../../search/models/search-filter-model';
import { DataTableEditorService } from '../../search/results/data-table-editor.service';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'lfwms-multi-po-populate-popup',
  templateUrl: './multi-po-populate-popup.component.html',
  styleUrls: ['./multi-po-populate-popup.component.css']
})
export class MultiPoPopulatePopupComponent {



  public lookupAlertService: AlertService;

  public lookupSearchService: SearchService;
  public confirmDialogService: ConfirmDialogService;
  public resourceService: ResourceService;
  /* Eventhough this variable is not needed here
   as it is provided in the action service where the popup is called,
    this variable must be oprovided to avoid --aot error*/
  public title: string;
  private buttonArray: Array<ButtonItem>;
  private callbackFunction: any;
  private parentRef: any;
  public onePoOneAsn: boolean = true;
  public parentDataService: any;
  public dataEditor: any;
  public defaultTdForSearch: any; // LFWM-2442 - get default td when user toggle between
  // populate from archive check box

  constructor(public modalService: ModalService,
    private coreServiceRegistry: CoreServiceRegistry,
    private sharedServiceRegistry: SharedServiceRegistry) {
    this.lookupAlertService = new AlertService();
    this.confirmDialogService = new ConfirmDialogService();
    this.resourceService = this.coreServiceRegistry.resourceService;
    this.buttonArray = [
      new ButtonItem('Populate', this.resourceService.get('Populate'), 'asn_mult_po', 'icon-populate-multi.svg', []),
      new ButtonItem('PopulateAll', this.resourceService.get('Populate All'), 'asn_mult_po', 'icon-populate-multi.svg', []) 
    ];
  }


  public registerCallback(callback: any, parentRef: any) {
    this.callbackFunction = callback;
    this.parentRef = parentRef;
  }

  public initializeComponents(dataService) {
    /* Data editor is needed  for searching in tableheader filter */
    this.parentDataService = dataService;
    this.lookupSearchService = this.createSearchService('potd');
    const searchCriteria = this.createSearchCriteria();
    const tableEditor: DataTableEditorService = new DataTableEditorService(this.coreServiceRegistry,
      this.sharedServiceRegistry);
    this.dataEditor = tableEditor;
    this.lookupSearchService.searchParams.tableEditor = tableEditor;
    this.lookupSearchService.setSearchCriteria(searchCriteria);
    this.defaultTdForSearch = this.lookupSearchService.searchParams.tableId;
  }

  public createSearchCriteria() {
    const defaultSearchCriteria = new SearchCriteria();
    defaultSearchCriteria.conditions = [];
    defaultSearchCriteria.loadDefaultCriteria = false;
    const defaultCondition1 = this.createDefaultSearchCondition(1);
    defaultCondition1.isReadOnly = true;
    defaultCondition1.isMandatory = true;
    defaultCondition1.operator = 'AND';
    const defaultClause1 = new Clause();
    defaultClause1.column = 'storerKey';
    defaultClause1.value = this.parentDataService.primaryDataMap['storerKey'].cVal;
    defaultClause1.operation = '=';
    defaultClause1.logicalOperation = 'AND';
    const defaultClause2 = new Clause();
    defaultClause2.column = 'externalPOStatus';
    defaultClause2.value = '0';
    defaultClause2.operation = '=';
    defaultClause2.logicalOperation = 'AND';
    defaultCondition1.clauses = [defaultClause1, defaultClause2];
    defaultSearchCriteria.conditions.push(defaultCondition1);
    return defaultSearchCriteria;
  }
  protected createDefaultSearchCondition(id) {
    const defaultCondition = new Condition();
    defaultCondition.id = id;
    defaultCondition.displayMode = 'VIEW';
    return defaultCondition;
  }


  private createSearchService(tableId: string): SearchService {
    const searchParams = new SearchParams();
    searchParams.tableId = tableId;
    searchParams.isFullFetch = true;
    searchParams.columnCount = 10;
    searchParams.defaultSearchColumn = '';
    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.supportFiltering = true;
    searchParams.dataTableConfig = tableConfig;
    searchParams.alertService = this.lookupAlertService;
    searchParams.actionButtons = this.buttonArray;
    searchParams.tableEditor = this.dataEditor;
    const searchStatus = new SearchStatus();
    const searchService = this.sharedServiceRegistry.createSearchService(searchParams, searchStatus);
      searchParams.idProperty = 'poKey';
    return searchService;
  }

  public getLabel(key: any) {
    return this.resourceService.get(key);
  }

  public handleButtonAction(action: string) {
    if (this.callbackFunction && action === 'Populate') {

      /*The no of lineitems is the no of asn main line items.If it is zero we dont
       have any line items to populate, but still the populate button can be clicked,
        and on clicking the button this error message should be displayed */
      const noOfLineItems = this.lookupSearchService.getPagedData().pageDefinition.recordCount;
      if (noOfLineItems === 0) {
        // No details available to proceed the action
        this.lookupAlertService.clearAll().error(this.resourceService.get('msg_no_detail'));
        return;
      }
      const selectedLineItems: any = this.lookupSearchService.getSelectedRows();
      if (selectedLineItems.length === 0) {
        this.lookupAlertService.clearAll().error(this.resourceService.get('msg_sel_detail'));
        return;
      }
      const poKeyList: Array<any> = [];
      for (let j = 0; j < selectedLineItems.length; j++) {
        poKeyList.push(selectedLineItems[j].cells['poKey'].cVal);
      }
      const populateType: string = (this.onePoOneAsn === false) ? '1PO1ASN' : 'MPO1ASN';
      const fetchDataFromArchiveDB: number = (this.lookupSearchService.searchParams.fetchArchiveRecords) ? 1 : 0 ;
      // LFWM-3191- passing tableId. 
      const populateRequest: any = {
        'asnNumber': this.parentDataService.primaryDataMap['receiptKey'].cVal,
        'poKeysList': poKeyList,
        'populateType': populateType,
        'populateFromArchive': fetchDataFromArchiveDB,
        'proceedWithWarning': 'N',
        'warningNo': 0,
        'tableId': this.parentDataService.primarySearchParams.tableId,
        'poType': 'populate'
      };
      this.callbackFunction(this.parentRef, populateRequest);
    }
    
    // LFWM-3874 Populate all po's at one time only (if more than 100)
    if (this.callbackFunction && action === 'PopulateAll') {
      const noOfLineItems = this.lookupSearchService.getPagedData().pageDefinition.recordCount;
      if (noOfLineItems === 0) {
        this.lookupAlertService.clearAll().error(this.resourceService.get('msg_no_detail'));
        return;
      }
      const populateType: string = (this.onePoOneAsn === false) ? '1PO1ASN' : 'MPO1ASN';
      const fetchDataFromArchiveDB: number = (this.lookupSearchService.searchParams.fetchArchiveRecords) ? 1 : 0;
      const populateRequest: any = {
        'searchRequest': {
          'pageInfo': {
            'tableId': 'potd',
            'pageNo': 1,
            'sortColumn': null,
            'sortOrder': 0,
            'pageSize': this.lookupSearchService.getPagedData().pageDefinition.recordCount,
            'fullFetch': true,
            'fetchAllrecords': false,
            'fetchArchiveRecords': false
          },
          'searchCriteria': this.formatSearchCriteria(this.lookupSearchService.getSearchCriteria())
        },
        'asnNumber': this.parentDataService.primaryDataMap['receiptKey'].cVal,
        'populateType': populateType,
        'populateFromArchive': fetchDataFromArchiveDB,
        'proceedWithWarning': 'N',
        'warningNo': 0,
        'tableId': this.parentDataService.primarySearchParams.tableId,
        'poType': 'populateAll'
      };
      this.callbackFunction(this.parentRef, populateRequest);
    }
  }

  public formatSearchCriteria(searchCriteria) {
    if (!searchCriteria) {
      return {};
    }
    let allConditions = null;
    // Code added to merge filter conditions with master search criteria, if filter condition is there.
    allConditions = searchCriteria.conditions;

    const conditionReqList = [];
    allConditions.forEach((condition: any, index: any) => {
      const clauseReqlist = [];
      condition.clauses.forEach((clause: any) => {
        if (clause.value !== undefined && clause.value !== null) {
          clauseReqlist.push({
            column: clause.column,
            operation: clause.operation,
            value: clause.value,
            value1: clause.value1,
            logicalOperation: clause.logicalOperation
          });
        }
      });
      if (clauseReqlist.length !== 0) {
        let logOp = null;
        if (index < allConditions.length - 1) {
          logOp = condition.operator;
        }
        conditionReqList.push({
          mandatory: condition.isMandatory,
          clauses: clauseReqlist,
          logicalOperation: logOp
        });
      }
    });
    return { conditions: conditionReqList };
  }


  // JIRA LFWM-1162 - Enabling Populate from Archive DB checkbox for Populate PO Popup
  public toggleCheckbox() {
    this.lookupSearchService.searchParams.fetchArchiveRecords = (this.lookupSearchService.searchParams.fetchArchiveRecords === false) ? true : false;
   //lfwm-3019 added the code for changing table id to archive table id on calling in archive mode
    this.lookupSearchService.searchParams.tableId = (this.lookupSearchService.searchParams.fetchArchiveRecords === true) ? 'poarchivetd' : this.defaultTdForSearch;
  }

  public toggleOnePoOneASn() {
    this.onePoOneAsn = (this.onePoOneAsn === false) ? true : false;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/populate-multi-po-popup/multi-po-populate-popup.component.ts